import {
  SnippetsOutlined,
  CommentOutlined,
  SecurityScanOutlined,
  UserAddOutlined,
  QuestionCircleOutlined,
  ProfileOutlined,
  ApartmentOutlined,
  PlusCircleOutlined,
  PieChartOutlined,
  FileDoneOutlined,
  LineChartOutlined,
  BarChartOutlined,
  IdcardOutlined,
  BarsOutlined,
  CompassOutlined,
} from '@ant-design/icons';
import {
  cadastroAtendente,
  requerimentos,
  requerimentosListarContribuinte,
  listarAtendente,
  rotaAtendente,
  privateRoot,
  dicionario,
  servicosSistemaListar,
  servicosSistemaCadastrar,
  setorSistemaCadastrar,
  setorSistemaListar,
  relatorioStatus,
  relatorioSolicitacoes,
  relatorioTipo,
  relatorioPerformanceGeral,
  relatorioPerformanceAtendente,
  dadosCadastraisRedirect,
  relatorioListarRequerimentos,
  postosAtendimentoListar,
  postosAtendimentoCadastrar,
} from 'routes/paths';
import { ENUM_TIPO_PERFIL } from 'utils/permissao';

export const getItensMenuDefault = (user, disabled = false) => {
  const perfilUsuario = user?.profile;
  const disabledMenu = disabled || !user;

  const isSupervisorOrSetorial =
    perfilUsuario === ENUM_TIPO_PERFIL.SUPERVISOR || perfilUsuario === ENUM_TIPO_PERFIL.SUPERVISOR_SETORIAL;

  return [
    {
      titulo: 'FAS',
      id: 'fas',
      icon: '',
      rota: perfilUsuario === ENUM_TIPO_PERFIL.ATENDENTE ? rotaAtendente : privateRoot,
      view: true,
      disabled: disabledMenu,
    },
    {
      titulo: 'Dados cadastrais',
      id: 'dadosCadastrais',
      icon: <IdcardOutlined />,
      rota: dadosCadastraisRedirect,
      view: perfilUsuario === ENUM_TIPO_PERFIL.CONTRIBUINTE,
      disabled: disabledMenu,
    },
    {
      titulo: 'Atendente',
      id: 'atendente',
      icon: <CommentOutlined />,
      view: isSupervisorOrSetorial,
      disabled: disabledMenu,
      subMenu: [
        {
          titulo: 'Listar',
          id: 'atendenteListar',
          icon: <SecurityScanOutlined />,
          rota: listarAtendente,
          view: isSupervisorOrSetorial,
          disabled: disabledMenu,
        },
        {
          titulo: 'Cadastrar',
          id: 'atendenteCadastrar',
          icon: <UserAddOutlined />,
          rota: cadastroAtendente,
          view: isSupervisorOrSetorial,
          disabled: disabledMenu,
        },
      ],
    },
    {
      titulo: 'Requerimentos',
      id: 'requerimentos',
      icon: <SnippetsOutlined />,
      rota: perfilUsuario === ENUM_TIPO_PERFIL.CONTRIBUINTE ? requerimentosListarContribuinte : requerimentos,
      view: true,
      disabled: disabledMenu,
    },
    {
      titulo: 'Dicionário',
      id: 'dicionario',
      icon: <QuestionCircleOutlined />,
      rota: dicionario,
      view: true,
      disabled: disabledMenu,
    },
    {
      titulo: 'Serviços',
      id: 'servico',
      icon: <ProfileOutlined />,
      view: isSupervisorOrSetorial,
      disabled: disabledMenu,
      subMenu: [
        {
          titulo: 'Listar',
          id: 'servicoListar',
          icon: <SecurityScanOutlined />,
          rota: servicosSistemaListar,
          view: isSupervisorOrSetorial,
          disabled: disabledMenu,
        },
        {
          titulo: 'Cadastrar',
          id: 'servicoCadastrar',
          icon: <PlusCircleOutlined />,
          rota: servicosSistemaCadastrar,
          view: perfilUsuario === ENUM_TIPO_PERFIL.SUPERVISOR,
          disabled: disabledMenu,
        },
      ],
    },
    {
      titulo: 'Setores',
      id: 'setor',
      icon: <ApartmentOutlined />,
      view: isSupervisorOrSetorial,
      disabled: disabledMenu,
      subMenu: [
        {
          titulo: 'Listar',
          id: 'setorListar',
          icon: <SecurityScanOutlined />,
          rota: setorSistemaListar,
          view: isSupervisorOrSetorial,
          disabled: disabledMenu,
        },
        {
          titulo: 'Cadastrar',
          id: 'setorCadastrar',
          icon: <PlusCircleOutlined />,
          rota: setorSistemaCadastrar,
          view: perfilUsuario === ENUM_TIPO_PERFIL.SUPERVISOR,
          disabled: disabledMenu,
        },
      ],
    },
    {
      titulo: 'Postos de Atendimento',
      id: 'postosAtendimento',
      icon: <CompassOutlined />,
      view: perfilUsuario === ENUM_TIPO_PERFIL.SUPERVISOR,
      disabled: disabledMenu,
      subMenu: [
        {
          titulo: 'Listar',
          id: 'postosAtendimentoListar',
          icon: <SecurityScanOutlined />,
          view: perfilUsuario === ENUM_TIPO_PERFIL.SUPERVISOR,
          rota: postosAtendimentoListar,
          disabled: disabledMenu,
        },
        {
          titulo: 'Cadastrar',
          id: 'postosAtendimentoCadastrar',
          icon: <PlusCircleOutlined />,
          view: perfilUsuario === ENUM_TIPO_PERFIL.SUPERVISOR,
          rota: postosAtendimentoCadastrar,
          disabled: disabledMenu,
        },
      ],
    },
    {
      titulo: 'Relatórios',
      id: 'relatorios',
      icon: <FileDoneOutlined />,
      view: isSupervisorOrSetorial,
      disabled: disabledMenu,
      subMenu: [
        {
          titulo: 'Status',
          id: 'RelatorioStatus',
          icon: <PieChartOutlined />,
          rota: relatorioStatus,
          view: isSupervisorOrSetorial,
          disabled: disabledMenu,
        },
        {
          titulo: 'Solicitações',
          id: 'RelatorioSolicitacoes',
          icon: <BarChartOutlined />,
          rota: relatorioSolicitacoes,
          view: isSupervisorOrSetorial,
          disabled: disabledMenu,
        },
        {
          titulo: 'Tipo',
          id: 'RelatorioTipo',
          icon: <BarChartOutlined />,
          rota: relatorioTipo,
          view: isSupervisorOrSetorial,
          disabled: disabledMenu,
        },
        {
          titulo: 'Listar Requerimentos',
          id: 'RelatorioListarRequerimentos',
          icon: <BarsOutlined />,
          rota: relatorioListarRequerimentos,
          view: perfilUsuario === ENUM_TIPO_PERFIL.SUPERVISOR,
          disabled: disabledMenu,
        },
        {
          titulo: 'Performance',
          id: 'RelatorioPerformance',
          icon: <LineChartOutlined />,
          view: isSupervisorOrSetorial,
          disabled: disabledMenu,
          subMenu: [
            {
              titulo: 'Geral',
              id: 'RelatorioPerformanceGeral',
              icon: <LineChartOutlined />,
              rota: relatorioPerformanceGeral,
              view: isSupervisorOrSetorial,
              disabled: disabledMenu,
            },
            {
              titulo: 'Atendente',
              id: 'RelatorioPerformanceAtendente',
              icon: <LineChartOutlined />,
              rota: relatorioPerformanceAtendente,
              view: perfilUsuario === ENUM_TIPO_PERFIL.SUPERVISOR,
              disabled: disabledMenu,
            },
            {
              titulo: 'Atendente Setorial',
              id: 'RelatorioPerformanceAtendenteSetorial',
              icon: <LineChartOutlined />,
              rota: `${relatorioPerformanceAtendente}/true`,
              view: isSupervisorOrSetorial,
              disabled: disabledMenu,
            },
          ],
        },
      ],
    },
  ];
};
